<loading-indicator [isVisible]="true" class="overlay"></loading-indicator>